import {TranslationObject} from '@colonist/i18n'
import {LobbyImage} from '@colonist/types'
import {UITopNotificationType} from '../../../shared/scripts/notifications/UINotificationController'
import {createDivIn, createImgIn, createLinkIn, setElementInnerHTML, setElementOnClick} from '../../../shared/scripts/ui_utils/DomUtils'
import {getNotificationIconForType} from '../../../shared/scripts/ui_utils/NotificationUtils.ts'

export class UITopNotificationView {
    private readonly container: HTMLDivElement
    protected readonly itemContainer: HTMLDivElement
    readonly type: UITopNotificationType

    constructor(text: TranslationObject, type: UITopNotificationType, buttonText?: TranslationObject, action?: () => void, removeAction?: () => void, showCloseButton: boolean = true, duration?: number) {
        this.type = type
        this.container = document.getElementById('top-notification-container') as HTMLDivElement
        this.itemContainer = createDivIn(this.container, 'top-notification')

        const contentWrapper = createDivIn(this.itemContainer, 'notification-content')
        createImgIn(contentWrapper, getNotificationIconForType(type), 'notification-icon')
        const textDiv = createDivIn(contentWrapper, '')
        setElementInnerHTML(textDiv, text)

        UITopNotificationView.createButton(contentWrapper, buttonText, action)

        if(duration !== undefined) {
            setTimeout(() => {
                this.hide()
            }, duration)
        }

        if(showCloseButton == false) return

        const closeButton = createImgIn(this.itemContainer, LobbyImage.XMark, 'top-notification-close-button')
        setElementOnClick(closeButton, () => {
            this.itemContainer.remove()
            if(removeAction != undefined) removeAction()
        })
    }

    hide() {
        this.itemContainer.remove()
    }

    private static createButton(parent: HTMLElement, buttonText?: TranslationObject, action?: () => void) {
        if(buttonText == undefined || action == undefined) return
        const button = createLinkIn(parent, '', buttonText, 'top-notification-button')
        setElementOnClick(button, () => action(), true)
    }
}
